export const sanitizeAadhaarNumber = (value = "") =>
  value.toString().replace(/\D/g, "").slice(0, 12);

// Verhoeff checksum tables (dihedral group D5). Aadhaar's 12th digit is a
// Verhoeff check digit, so this rejects typos / invalid numbers with no API.
const VERHOEFF_D = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
  [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
  [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
  [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
  [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
  [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
  [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
  [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
  [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
];
const VERHOEFF_P = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
  [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
  [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
  [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
  [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
  [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
  [7, 0, 4, 6, 9, 1, 3, 2, 5, 8],
];

// Structural check only (not proof the Aadhaar is issued): 12 digits, never
// starts 0/1, and a valid Verhoeff checksum.
export const isValidAadhaar = (value = "") => {
  const num = sanitizeAadhaarNumber(value);
  if (num.length !== 12) return false;
  if (num[0] === "0" || num[0] === "1") return false;
  let c = 0;
  for (let i = 0; i < num.length; i++) {
    c = VERHOEFF_D[c][VERHOEFF_P[i % 8][Number(num[num.length - 1 - i])]];
  }
  return c === 0;
};
